<div style="padding: 24px">
    <div class="one-row">
        <h2>Leistungen</h2>
        <span class="spacer"></span>
        <button
            (click)="openHotKeyDialog()"
            *kienePermission="[2682]"
            [matTooltip]="'Neue Belegvorlage erstellen'"
            color="accent"
            mat-icon-button
        >
            <mat-icon> format_list_bulleted_add </mat-icon>
        </button>
    </div>

    <div class="one-row">
        <mat-form-field>
            <mat-label>Tier</mat-label>
            <mat-select [formControl]="tierCtrl" [compareWith]="tierComparator">
                <mat-option *ngFor="let tier of tiere" [value]="tier"
                    >{{ tier?.name }}&nbsp;|&nbsp;{{ tier?.tierart }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <kiene-article-scan-autocomplete
            [kuerzel]="true"
            [disabled]="disabled || heimtierBeleg?.status_id === 223"
            #articleAutocomplete
            (selectedMaterial)="setSelectedMaterial($event)"
            [placeholder]="getPlaceholderArtikel()"
            [gesperrtAusblenden]="true"
            [showPrice]="true"
            [kundeId]="heimtierBeleg?.kunde_id"
            [required]="true"
            [focus]="focusOnInit"
            (cleared)="materialInputCleared()"
            [nurAbgegebeneArtikel]="false"
            [params]="limit20"
            [debounceTimeMs]="100"
            style="min-width: 400px; width: 15%"
        >
        </kiene-article-scan-autocomplete>

        <kiene-anwendungs-selector
            #anwendungSelector
            style="width: 10%"
            [required]="false"
            [disabled]="istMengenArtikel() || disabled || heimtierBeleg?.status_id === 223"
            (change)="setSelectedAnwendung($event)"
        >
        </kiene-anwendungs-selector>

        <kiene-diagnose-selector
            #diagnoseSelector
            style="width: 15%"
            [disabled]="istMengenArtikel() || disabled || heimtierBeleg?.status_id === 223"
            [required]="false"
            (change)="setSelectedDiagnose($event)"
        >
        </kiene-diagnose-selector>

        <mat-form-field *ngIf="istAbgabeUndBehandlung()" style="width: 5%">
            <mat-label>Behandlung:</mat-label>
            <mat-select #behandlungJaNein [formControl]="behandlungJaNeinCtrl" [disabled]="disabled">
                <mat-option [value]="true">Ja</mat-option>
                <mat-option [value]="false">Nein</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field style="width: 8%">
            <mat-label>Anwendungsdauer</mat-label>
            <input
                #anwendungsdauer="matInput"
                matInput
                type="number"
                [formControl]="anwendungsdauerCtrl"
                (change)="anwendungsdauerChange()"
            />
        </mat-form-field>

        <mat-form-field style="width: 70px">
            <mat-label>Menge {{ mengeExakt }}</mat-label>
            <input (change)="mengeChange()" [formControl]="mengeCtrl" matInput type="number" />
        </mat-form-field>

        <mat-form-field style="width: 70px">
            <mat-label>Faktor</mat-label>
            <input (change)="faktorChange()" [formControl]="faktorCtrl" matInput type="number" />
        </mat-form-field>

        <mat-form-field style="width: 12%">
            <mat-label>{{ position?.dosierung_txt ? position.dosierung_txt : "Dosierung" }}</mat-label>

            <input matInput type="number" [formControl]="dosierungCtrl" (blur)="onBlurDosierung()" />
        </mat-form-field>

        <button
            (click)="savePosition()"
            [disabled]="isSaving || heimtierBeleg?.status_id === 223"
            color="accent"
            mat-icon-button
        >
            <mat-icon>{{ position?.hba_id ? "save" : "add" }}</mat-icon>
        </button>
    </div>

    <table class="phito-table leistungen-table">
        <thead>
            <tr>
                <th></th>
                <th>Pos.</th>
                <th>Tier</th>
                <th>Artikel</th>
                <th>Anwendung</th>
                <th>Diagnose</th>
                <th>Behandlung</th>
                <th>AD</th>
                <th>Menge</th>
                <th>Faktor</th>
                <th>Dos</th>
                <th>Einzelpreis</th>
                <th>Summe</th>
                <th></th>
            </tr>
        </thead>
        <tbody (cdkDropListDropped)="onPositionDrop($event)" cdkDropList>
            <tr (click)="editPosition(pos)" *ngFor="let pos of heimtierBeleg?.positionen; let i = index" cdkDrag>
                <td cdkDragHandle style="cursor: move">
                    <mat-icon>drag_indicator</mat-icon>
                </td>
                <td>{{ i + 1 }}</td>
                <td>{{ pos?.name }}</td>
                <td>{{ pos?.artikel_me }}</td>
                <td>{{ pos?.anwendung }}</td>
                <td>{{ pos?.diagnose }}</td>
                <td>{{ KieneUtils.isApiOne(pos?.behandlung) ? "ja" : "nein" }}</td>
                <td>{{ pos?.anwendungsdauer }}</td>
                <td>{{ pos?.artikelmenge }}</td>
                <td>{{ pos?.faktor }}</td>
                <td>{{ pos?.dosierung }}</td>
                <td>{{ pos?.einzelpreis_manuell || pos?.einzelpreis | number: "1.2-2" }}&euro;</td>
                <td
                    >{{
                        (pos?.einzelpreis_manuell || pos?.einzelpreis) * pos?.artikelmenge * (pos?.faktor || 1)
                            | number: "1.2-2"
                    }}&euro;</td
                >
                <td>
                    <button #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu" color="accent" mat-icon-button>
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu" [hasBackdrop]="true">
                        <button (click)="editPreis(pos)" [disabled]="heimtierBeleg?.status_id === 223" mat-menu-item>
                            <mat-icon>edit</mat-icon>
                            <span>Preis anpassen</span>
                        </button>
                        <button
                            (click)="removePosition(pos)"
                            *ngIf="!pos?.aus_stueckliste"
                            [disabled]="heimtierBeleg?.status_id === 223"
                            mat-menu-item
                        >
                            <mat-icon>delete</mat-icon>
                            <span>Löschen</span>
                        </button>
                    </mat-menu>
                </td>
            </tr>
            <tr>
                <td class="spacer" colspan="11"></td>
                <td><strong>Gesamt:</strong></td>
                <td
                    ><strong>{{ gibGesamtpreis() | number: "1.2-2" }}&euro;</strong></td
                >
                <td></td>
            </tr>
        </tbody>
    </table>
</div>
